<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div class="row">
        <!-- Product -->
        <div class="col-sm-6">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-file"></i><strong>Product</strong>
            </div>
            <div class="card-block">
              <div class="form-group">
                <label for="id">ID</label>
                <input type="text" class="form-control" id="id" v-model="product.id" readonly>
              </div>

              <div class="form-group">
                <label for="codename">Codename</label>
                <input type="text" class="form-control" id="codename" v-model="product.codename" readonly>
              </div>

              <div class="form-group">
                <label for="data_provider">Data Provider</label>
                <input type="text" class="form-control" id="data_provider" v-model="product.data_provider" readonly>
              </div>

              <div class="form-group">
                <label for="addon_type">Addon Type</label>
                <input type="text" class="form-control" id="addon_type" v-model="product.addon_type" readonly>
              </div>
            </div>
          </div>
        </div>

        <!-- Files -->

        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <i class="fa fa-align-justify"></i> Files
              </div>
              <div class="card-block">
                <table class="table table-bordered table-striped table-condensed">
                  <thead>
                    <tr>
                      <th>Canonical URL</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="file in product.product_files">
                      <td><router-link :to="{ name: 'File', params: {id: encodeCanonicalURL(file)} }">{{file.canonical_url}}</router-link></td>
                      <td>{{file.updated_at | moment('LLL')}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

    </div>
  </div>
</div>
</template>


<script>
import products from 'services/products'
import utils from 'services/utils'

export default {
  name: 'product',
  data () {
    return {
      product: {}
    }
  },
  created () {
    this.getProduct()
  },
  methods: {
    getProduct () {
      products.get(this, this.$route.params.id)
    },
    encodeCanonicalURL (file) {
      return btoa(file.canonical_url)
    }
  },
  filters: {
    parseTimestamp (timestamp) {
      return utils.parseTimestamp(timestamp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Product.vue